export default "__VITE_ASSET__BzLkbJ4w__"